export default __webpack_public_path__ + "static/media/marko_xl.739074dd.jpg";